// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1h0g_","calendarButtons":"ClockData_calendarButtons__3MzF6"};